import React from "react";
import { Layout } from "Components/Layout/Layout";
import { lazyLoader } from "Service/loader";

const ReportsStatusSummaryList = lazyLoader(
  () =>
    import(
      "Containers/Reports/ReportsInnerPages/ReportsStatusSummary/ReportsStatusSummaryList/ReportsStatusSummaryList"
    )
);
export const ReportsStatusSummary = () => {
  return (
    <Layout>
      <ReportsStatusSummaryList />
    </Layout>
  );
};
